import { UseFormReturn } from 'react-hook-form'
import { Column } from 'src/shared/components/Semantic/all'
import { FormInput } from 'src/shared/components/FormComponents'
import type { SignupSuccessFormData } from '../types'

interface CompanyInformationSectionProps {
  methods: UseFormReturn<SignupSuccessFormData>
}

export const CompanyInformationSection = ({
  methods,
}: CompanyInformationSectionProps) => {
  return (
    <Column className="gap-4">
      <h2>Company</h2>
      <FormInput
        label="Company name"
        name="companyName"
        methods={methods}
        className="w-full"
      />
    </Column>
  )
}
